import { component } from 'picoapp';
import Swiper, { Pagination, Navigation } from 'swiper';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const config = JSON.parse(node.dataset.config);
  const { productID, baseURL, limit } = config;

  const sliderElement = node.querySelector('.js-slider');
  const paginationElement = node.querySelector('.js-pagination');
  const output = node.querySelector('.js-output');
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        const newNodes = Array.from(mutation.addedNodes);
        const newMediaSliderElements = newNodes.filter((node) => node.classList && node.classList.contains('product-slider__item'));
        if (newMediaSliderElements.length > 0) {
          initializeProductCard(newMediaSliderElements);
        }
      }
    });
  });

  const initializeProductCard = (newMediaSliderElements) => {
    newMediaSliderElements.forEach((slider) => {
      const swiperElement = slider.querySelector('.product__media-slider');
      swiperElement.setAttribute('navigation', true);
      const paginationElement = slider.querySelector('.js-pagination');
      new Swiper(swiperElement.querySelector('.swiper'), {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        grabCursor: false,
        allowTouchMove: false,
        navigation: {
          prevEl: slider.querySelector('.js-mediaSliderPrevBtn'),
          nextEl: slider.querySelector('.js-mediaSliderNextBtn'),
        },
        pagination: {
          el: paginationElement,
          type: 'bullets',
          bulletClass: 'product-slider__pagination__bullet',
          bulletActiveClass: 'product-slider__pagination__bullet--active',
        },
      });
    });
  };

  observer.observe(node, {
    subtree: true,
    childList: true,
  });

  /**
   * Functions
   */
  const getMarkup = () => {
    const endpoint = `${baseURL}?section_id=product-related&product_id=${productID}&limit=${limit}`;

    return fetch(endpoint, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then((response) => response.text());
  };

  const init = async () => {
    const markup = await getMarkup();
    const container = document.createElement('div');
    container.innerHTML = markup;

    output.innerHTML = container.querySelector('.js-output').innerHTML;

    (() => new Swiper(sliderElement, {
      modules: [Pagination],
      slidesPerView: 'auto',
      grabCursor: true,
      pagination: {
        el: paginationElement,
        type: 'bullets',
        bulletClass: 'product-slider__pagination__bullet',
        bulletActiveClass: 'product-slider__pagination__bullet--active',
      },
    }))();
  };

  /**
   * Init
   */
  init();
});
